import styled from 'styled-components';
import getColour from '@lendi-ui/commons/colours';
import { m, p, pb, pt, px, py } from '@lendi-ui/spacing';
import { body } from '@lendi-ui/typography';

interface TableContainerProps {
  top: string;
  tableSize: { min: string; max: string };
  headerSizes: { width: string; min: string; max: string }[];
  isSticky?: boolean;
}

export const TableContainer = styled.div<TableContainerProps>`
  ${body()}
  overflow-x: auto;

  table,
  thead,
  tbody,
  tfoot,
  tr,
  th,
  td {
    box-sizing: border-box;
    position: relative;
  }

  table,
  thead,
  tbody,
  tfoot {
    display: block;
  }

  th {
    display: inline-block;
  }

  tr {
    display: flex;
  }

  td {
    display: flex;
    align-items: center;
  }

  table {
    border: none;
    border-spacing: 0;
    ${m('nil')}
    ${p('nil')}
    ${(props) => `
      min-width: ${props.tableSize.min};
      max-width: ${props.tableSize.max};
    `}
  }

  thead {
    background-color: ${() => getColour('shade', 0)};

    tr {
      border-bottom: 1px inset ${() => getColour('shade', 50)};
    }

    th {
      background-color: ${() => getColour('shade', 0)};
      text-align: left;

      ${body({ size: 'xs' })}
    }
  }

  tbody {
    tr {
      &:nth-child(even) {
        &,
        td:nth-child(1) {
          background-color: ${() => getColour('shade', 0)};
        }
      }
      &:nth-child(odd) {
        &,
        td:nth-child(1) {
          background-color: ${() => getColour('shade', 50)};
        }
      }
      &.runningTotal {
        &,
        td:nth-child(1) {
          background-color: ${() => getColour('shade', 200)};
        }
      }
    }

    td {
      ${body({ size: 'sm' })}
    }
  }

  thead tr th,
  tbody tr td {
    padding: 0 10px;

    ${py('xs')}
    ${(props) =>
      props.headerSizes.reduce(
        (str, size, index) => `
          ${str}
          &:nth-child(${index + 1}) {
            width: ${size.width};
            min-width: ${size.min};
            max-width: ${size.max};
          }
        `,
        ''
      )}

    ${(props) =>
      props.isSticky &&
      `
        &:nth-child(1) {
          left: 0px;
          position: sticky;
        }
    `}
  }

  tfoot td {
    ${pb('lg')}
    ${pt('xs')}
    ${px('sm')}

    ${(props) =>
      props.isSticky &&
      `
        &:nth-child(1) {
          left: 0px;
          height: 100%;
          position: sticky;
        }
    `}
  }
`;
